const AppIcon = `
	<?xml version="1.0" encoding="utf-8"?>
	<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
		viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve">
	<style type="text/css">
	 .st0{fill:#969696;}
	 .st1{font-family:'MyriadPro-Bold';}
	 .st2{font-size:10.4869px;}
	</style>
	<path class="st0" d="M27,7.8c0.3,0.3,0.5,0.7,0.8,1.2c0.3,0.5,0.4,1,0.4,1.4v18.3c0,0.4-0.2,0.8-0.4,1.1c-0.4,0.2-0.7,0.4-1.2,0.4
	 H5.3c-0.4,0-0.8-0.2-1.1-0.4c-0.3-0.3-0.4-0.6-0.4-1.1V3.3c0-0.4,0.2-0.8,0.4-1.1s0.6-0.4,1.1-0.4h14.2c0.4,0,0.9,0.1,1.4,0.4
	 c0.5,0.3,0.9,0.4,1.2,0.8L27,7.8z M20,3.9v5.9H26c-0.1-0.3-0.2-0.5-0.4-0.6l-5-5C20.6,4.2,20.3,4,20,3.9z M26.1,28.1V11.9h-6.6
	 c-0.4,0-0.8-0.2-1.1-0.4c-0.3-0.3-0.4-0.6-0.4-1.1V3.9H5.9v24.3C5.9,28.1,26.1,28.1,26.1,28.1z"/>
	<text transform="matrix(0.9036 0 0 1 6.9415 24.9971)" class="st0 st1 st2">dcm</text>
	</svg>
`;

export default AppIcon;
